import Model, { ID, IsoDateTime } from 'src/models/Model'
import Movie from 'src/models/movie/Movie'
import Order from 'src/models/order/Order'
import User from 'src/models/user/User'

export const RATING_ICONS = [
  'sentiment_very_dissatisfied',
  'sentiment_dissatisfied',
  'sentiment_satisfied',
  'sentiment_very_satisfied'
]

export const RATING_ICONS_COLORS = [
  'red-13',
  'red-5',
  'green-5',
  'green-8'
]

export default class VisitReview extends Model {
  static name = 'VisitReview'

  static versioned = true
  static paginate = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true,
        sortable: true
      },
      user: {
        type: User,
        output: true
      },
      movie: {
        type: Movie,
        output: true
      },
      order: {
        type: Order,
        output: true
      },
      employee: {
        type: User,
        output: true
      },
      movieRating: {
        type: Number,
        default: null
      },
      staffRating: {
        type: Number,
        default: null
      },
      overallRating: {
        type: Number,
        default: null
      },
      cleanlinessRating: {
        type: Number,
        default: null
      },
      comments: {
        type: String,
        default: null
      },
      createdAt: {
        type: IsoDateTime,
        sortable: true,
        output: true
      }
    }

    this.queries = {
      findVisitReviewByToken: {
        arguments: {
          token: {
            type: String,
            required: true
          },
          movieRating: {
            type: String,
            required: false
          }
        },
        results: {
          visitReview: VisitReview
        }
      }
    }
  }
}
